import classNames from 'classnames';
import { nanoid } from 'nanoid';
import React, { JSX, useEffect, useState } from 'react';

interface Props {
  active?: boolean;
  onToggle?: (active: boolean) => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
}

export default function Toggle({ active = false, onToggle, disabled, loading, className }: Props): JSX.Element {
  const [toggleActive, setToggleActive] = useState<boolean>(active);
  const toggleName = `toggle_${nanoid()}`;

  /**
   * When the user toggled the checkbox
   */
  const onChange = (): void => {
    setToggleActive(prevState => !prevState);
    onToggle?.(!toggleActive);
  };

  // loading = true;

  useEffect(() => {
    setToggleActive(active);
  }, [active]);

  return (
    <>
      <div
        className={classNames('relative inline-block align-middle select-none duration-150 ease-in transition-all', 'w-10', className, {
          '!w-6': loading,
          'cursor-not-allowed': loading,
          'before:animate-spin before:z-20 before:rounded-t-full before:border-transparent before:border-t-primary before:border-4 before:w-full before:h-full before:absolute':
            loading,
        })}
      >
        <input
          disabled={disabled || loading}
          onChange={onChange}
          type='checkbox'
          name={toggleName}
          id={toggleName}
          className={classNames('absolute block rounded-full border-4 appearance-none bg-white transition-all', 'w-6 h-6', {
            'right-0 border-primary': toggleActive,
            'border-gray-300': !toggleActive,
            'border-primary/25': toggleActive && (disabled || loading),
            'cursor-pointer': !(disabled || loading),
            'cursor-not-allowed': disabled || loading,
          })}
        />
        <label
          htmlFor={toggleName}
          className={classNames('block overflow-hidden rounded-full', 'h-6', {
            'bg-gray-300': !toggleActive,
            'bg-primary': toggleActive,
            'bg-primary/25': toggleActive && (disabled || loading),
            'cursor-pointer': !(disabled || loading),
            'cursor-not-allowed': disabled || loading,
          })}
        />
      </div>
    </>
  );
}
